import { render, staticRenderFns } from "./FELIR.vue?vue&type=template&id=4571f24c&"
import script from "./FELIR.vue?vue&type=script&lang=js&"
export * from "./FELIR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports